import { colors } from '@hero/web-theme';

export const useMapMarkerColors = () => {
  const primary = colors.primary.DEFAULT;
  const green = '#36B37E';
  const orange = '#f97316';
  const red = '#EF4444';

  const getColor = (fillColor: string, paluse?: string) => {
    return { fillColor, paluse: paluse || fillColor };
  };

  const markerColors = {
    /** the color for the default location marker */
    default: getColor(primary),
    pending: getColor(orange),
    pickup: getColor(primary),
    dropoff: getColor(green),
    notAccurateLocation: getColor(red),
  };

  return { markerColors };
};
